import React, { useContext } from "react";
import { SelectButton } from "primereact/selectbutton";
import { SettingsContext } from "./SettingsContext.tsx";
import { useTranslation } from "../../Shared/i18n/useTranslation.ts";

/**
 * The printed language of the worksheet (ADR 0016; widened in ADR 0051 part
 * 3). Word-problem stories were the only thing this ever changed; since part
 * 3 translated every format's prompts and the shared PDF chrome, it applies
 * to every format, not word problems alone (see `showsLanguage` below).
 *
 * This is content, not interface: the interface locale is a separate value
 * (ADR 0051 §6/§7) that this control does not touch.
 */
const OPTIONS = [
    { label: "English", value: "en" },
    { label: "Español", value: "es" },
    { label: "Français", value: "fr" },
];

export function LanguageSettings() {
    const { settings, setSettings } = useContext(SettingsContext);
    const t = useTranslation();

    return (
        <div className="languageSettingsContainer">
            <div className="selectContainer">
                <span className="settingLabel">{t('settings.printedLanguageLabel')}</span>
            </div>
            <SelectButton
                value={settings.Language ?? "en"}
                onChange={(e) => e.value && setSettings({ ...settings, Language: e.value })}
                options={OPTIONS}
                optionLabel="label"
                className="select regrouping"
                aria-label={t('settings.printedLanguageAria')}
            />
        </div>
    );
}

export default LanguageSettings;
